import {DateRange} from '@hconnect/uikit/src/common'

export const mapDateRangeToQuery = (dateRange: DateRange<Date>) => {
  if (!dateRange.from || !dateRange.to) {
    throw new Error('Invalid date range')
  }

  const from = dateRange.from
  const to = dateRange.to

  const fromMonth = from.getMonth() + 1
  const fromYear = from.getFullYear()

  let toMonth = to.getMonth() + 2
  let toYear = to.getFullYear()

  if (toMonth === 13) {
    toMonth = 1
    toYear += 1
  }

  return {
    fromYear,
    fromMonth,
    toYear,
    toMonth
  }
}